import { ReactElement } from 'react';
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from '@mui/icons-material';
import { useTheme, IconButton } from '@mui/material';
import { SortDirection } from '../../types/domainTypes';

type Props = {
  sortDirection: SortDirection;
  onSetSortDirection: () => void;
};

export function SortDirectionIcon({ sortDirection, onSetSortDirection }: Props): ReactElement {
  const theme = useTheme();
  const icon =
    sortDirection === SortDirection.Ascending ? (
      <ArrowUpwardOutlined sx={{ color: theme.palette.text.primary }} />
    ) : (
      <ArrowDownwardOutlined sx={{ color: theme.palette.text.primary }} />
    );
  return <IconButton onClick={onSetSortDirection}>{icon}</IconButton>;
}
